import { render } from "./NomineeProfilePay.vue?vue&type=template&id=db5b8788&scoped=true"
import script from "./NomineeProfilePay.vue?vue&type=script&lang=js"
export * from "./NomineeProfilePay.vue?vue&type=script&lang=js"

import "./NomineeProfilePay.vue?vue&type=style&index=0&id=db5b8788&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5b8788"]])

export default __exports__